import { render } from "./BannerSwiper.vue?vue&type=template&id=2b6d4c34&scoped=true&ts=true"
import script from "./BannerSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerSwiper.vue?vue&type=script&setup=true&lang=ts"

import "./BannerSwiper.vue?vue&type=style&index=0&id=2b6d4c34&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6d4c34"],['__file',"src/components/home/BannerSwiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b6d4c34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b6d4c34', __exports__)) {
    console.log('reload')
    api.reload('2b6d4c34', __exports__)
  }
  
  module.hot.accept("./BannerSwiper.vue?vue&type=template&id=2b6d4c34&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2b6d4c34', render)
  })

}


export default __exports__